"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FilterInput = void 0;

var React = _interopRequireWildcard(require("react"));

var _CloseCircleIcon = require("../../../svgs/CloseCircleIcon");

var _MagnifyingGlassIcon = require("../../../svgs/MagnifyingGlassIcon");

var _LabeledInput = require("../../LabeledInput");

var _Clickable = require("../../Clickable");

var _FilterSelectContext = require("./FilterSelectContext");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FilterInput = function FilterInput(props) {
  var _useFilterSelectConte = (0, _FilterSelectContext.useFilterSelectContext)(),
      query = _useFilterSelectConte.query,
      setQuery = _useFilterSelectConte.setQuery,
      placeholder = _useFilterSelectConte.placeholder;

  var ref = (0, React.useRef)(null);

  var handleChange = function handleChange(event) {
    setQuery(event.target.value);
  };

  var handleClick = function handleClick() {
    var _ref$current;

    setQuery("");
    (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.focus();
  };

  return /*#__PURE__*/React.createElement(_LabeledInput.LabeledInput, _extends({
    ref: ref,
    role: "search",
    label: query !== "" ?
    /*#__PURE__*/
    // Active state
    React.createElement(_Clickable.Clickable, {
      display: "flex",
      onClick: handleClick,
      "aria-label": "Clear search input"
    }, /*#__PURE__*/React.createElement(_CloseCircleIcon.CloseCircleIcon, null)) :
    /*#__PURE__*/
    // Resting state
    React.createElement(_MagnifyingGlassIcon.MagnifyingGlassIcon, {
      style: {
        pointerEvents: "none"
      }
    }),
    onChange: handleChange,
    value: query,
    placeholder: placeholder
  }, props));
};

exports.FilterInput = FilterInput;
FilterInput.displayName = "FilterInput";
//# sourceMappingURL=FilterInput.js.map